export default "__VITE_ASSET__DXAw8sdm__"